import { render, staticRenderFns } from "./SalesResources.vue?vue&type=template&id=39567050&"
import script from "./SalesResources.vue?vue&type=script&lang=js&"
export * from "./SalesResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports